import { sectionNames } from "@saleor/intl";
import { RemittanceRunnerListUrlQueryParams } from "@saleor/remittanceRunner/url";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import RiderReminderList from "./views/RiderReminderList";

const RemittanceReminderList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substring(1));
  const params: RemittanceRunnerListUrlQueryParams = qs;

  return <RiderReminderList params={params} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.riderRemittance)} />
      <Routes>
        <Route path={""} element={<RemittanceReminderList />} />
      </Routes>
    </>
  );
};

export default Component;
